import React, { useState, useEffect, Fragment } from 'react';
import {
  Row, Card, CardBody, Input, CustomInput, Modal, ModalHeader, Button,
  ModalBody, ModalFooter, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getUserID, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  API_TODO_JSON,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import Json from '../../propinfo/json';
import { connect } from 'react-redux';
import moment from 'moment';
import ToDoList from './Components/toDoList';
import Validation from '../../../../../components/Validation';

function ToDo({ propertyId }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [toggleData, setToggleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [json, setJson] = useState('');
  const [item, setItem] = useState('');
  const [updateModal, setUpdateModal] = useState('');
  const [dropDownToggle, setDropDownToogle] = useState();
  const [allData, setAllData] = useState([]);
  const [showApprovalGroups, setShowApprovalGroups] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  useEffect(() => {
    LoadData();
  }, [propertyId]);
  const togglegallery = (index) => {
    setGalleryVisible(!galleryVisible);
  };
  const LoadData = () => {
    try {
      AxiosAPI({
        method: 'get',
        url: `${API_TODO_JSON}/all`,
      }).then((res) => {
        let obj = res.data;
        obj = obj.map((m) => {
          m.isSelected = false;
          return m;
        });
        let allObj = [];
        obj.map((m) => {
          allObj.push({
            "id": m.id,
            "title": m.title,
            "subTitle": m.subTitle,
            "icon": m.icon,
            "category": m.category,
            "startDate": m.startDate,
            "endDate": m.endDate,
            "text": m.text,
            "links": m.links,
            "status": m.status,
            "country": m.country,
            "note": m.note
          });
        });
        setAllData(allObj);
        setLoading(false);
        setToggleData(obj);
      });
    } catch { }
  };
  const handleSubmit = ({ m }) => {    
    if (item !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_TODO_JSON}/update/${item.id}`,
        data: {
          groupId: getGroupID(),
          propertyId: propertyId,
          type: 'SuperAdmin',
          Note: item.note,
          default: item.default,
          status: item.status,
          toDo: item,
        }
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          LoadData();
          setUpdateModal(false);
          // setApiState('success');
          // csvExporter.generateCsv(res.data);
        }
      });
    }
  }

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }
  const selectedImage = (data) => {
    setJson(data);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Export/Import To-Do
                </ModalHeader>
                <ModalBody>
                  <Json
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                    LoadData={LoadData}
                    exportAllData={exportAllData}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const exportData = (item) => {
    const json = JSON.stringify([[
      item
    ]]);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = "currentTo-Do.json";

    link.click();
  };
  const exportAllData = (item) => {
    const json = JSON.stringify([
      allData
    ]);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = "currentTo-Do.json";

    link.click();
  };

  return (
    <Fragment>
      <Row className="d-flex justify-content-end my-2">
        <Button color="primary" onClick={() => setGalleryVisible(!galleryVisible)} >Add New</Button>
      </Row>
      <Row className="mt-3">
        <Colxx xxs="12">
          {toggleData.length > 0 && toggleData.map((item) =>
            <ToDoList exportData={exportData} setGalleryVisible={() => {
              setItem(item);
              setGalleryVisible(!galleryVisible)
            }}
              item={item} handleSubmit={handleSubmit}
              updateModal={updateModal}
              setUpdateModal={(item) => {
                setDropDownToogle(item.status);
                setItem(item);
                setUpdateModal(true);
              }}>
            </ToDoList>
          )}
        </Colxx>
      </Row>
      <Row>
      </Row>
      {ImageGalleryButton()}
      <Modal
        isOpen={updateModal}
        toggle={() => setUpdateModal(!updateModal)}
        style={{ maxWidth: '500px' }}
      >
        <ModalHeader toggle={() => setUpdateModal()}>
          To-DO List
        </ModalHeader>
        <ModalBody>
          <div className='d-flex'>
            <h4 className='mr-2'>Status :</h4>
            <UncontrolledDropdown style={{ width: '20rem' }} className="w-15 text-center w-sm-100">
              <DropdownToggle caret color="outline-dark" size="xs">
                {dropDownToggle}
              </DropdownToggle>
              <DropdownMenu style={{ width: '20rem' }}>
                <DropdownItem onClick={() => {
                  setItem({ ...item, status: 1 });
                  setDropDownToogle('Active');
                }}>
                  Active
                </DropdownItem>
                <DropdownItem onClick={() => {
                  setItem({ ...item, status: 2 });
                  setDropDownToogle('Inactive');
                }}>
                  Inactive
                </DropdownItem>
                <DropdownItem onClick={() => {
                  setItem({ ...item, status: 3 });
                  setDropDownToogle('Archieved');
                }}>
                  Archieved
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleSubmit(item)}>Submit</Button>
          <Button className="ml-2" onClick={() => setUpdateModal(!updateModal)}>Close</Button>
        </ModalFooter>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, userId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(ToDo));
